export class BaseSplide {
  constructor(selector, options = {}) {
    this.selector = selector;
    this.options = options;
    this.splide = null;
  }

  // 基本設定を持つメソッド
  baseOptions() {
    return {
      speed: 400,
      autoplay: true,
    };
  }

  // スライダーを初期化するメソッド
  init() {
    // querySelectorでthis.selectorが存在しない場合は処理を終了する
    if (!document.querySelector(this.selector)) {
      return;
    }

    this.splide = new Splide(this.selector, {
      ...this.baseOptions(),
      ...this.options
    });

    this.bindEvents();

    this.start();
  }

  start() {
    this.splide.mount();
  }

  bindEvents() {
    // Base class does not bind any events. Subclasses should override this method to bind custom events.
  }
}
